import type { ControllerId } from "../controller/type";

let id = 0;
export const generateControllerId = (): ControllerId => {
  return String(++id);
};
